<app-nav></app-nav>
<section class="TeamCheckIn">
  <div class="container">
    <div class="col">
      <div *ngFor="let detail of teamMemberList | orderBy: 'name'">


        <div *ngFor="let userTimeDetail of daysOnTimeAndLeavesLeft">

          <div class="row team-grid {{detail.memberSupervisorCheck}}"
            *ngIf="detail.memberUserID == userTimeDetail.userId"
            [ngClass]="{'grid-shadow': detail.memberSupervisorCheck}">

            <div class="col-2 days-count no-padding text-center">
              <label class="count" id="countDaysOnTime">{{detail.countDaysOnTime}}</label>
              <label class="title">Days on time</label>
            </div>
            <div class="col-8 leave-action">
              <div class="row">
                <div class="col">
                  <label *ngIf="!detail.memberSupervisorCheck" class="name" id="name">{{detail.name}}</label>
                  <a *ngIf="detail.memberSupervisorCheck" class="name text-anchor" id="name"
                    (click)="getTeamListAgain(detail.memberUserID)">{{detail.name}}</a>
                </div>
                <div class="col text-right no-padding">
                  <button class="btn btn-check-self" (click)="openConfirmModal(detail.memberUserID, 'IN');"
                    data-toggle="modal">In</button>
                  <button class="btn btn-check-self" (click)="openConfirmModal(detail.memberUserID,'OUT');"
                    data-toggle="modal">Out</button>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <img *ngIf="userTimeDetail.inStatus" class="hiddenCheckMark"
                    src="assets/images/simplegreencheckmark.png" width="15">
                </div>
                <div class="col-10 text-right no-padding">
                  <button class="btn btn-check-in" [ngClass]="{'btn-request-pending': detail.isCheckIn}"
                    data-toggle="modal" (click)="openCheckInModal(detail.memberUserID)">In</button>
                  <button class="btn btn-check-out" [ngClass]="{'btn-request-pending': detail.isCheckOut}"
                    data-toggle="modal" (click)="openCheckOutModal(detail.memberUserID)">Out</button>
                  <button class="btn btn-check-leave" [ngClass]="{'btn-request-pending': detail.isLeave}"
                    data-toggle="modal" (click)="openLeaveApproveModal(detail.memberUserID)">Leave</button>
                    <div>
                      <button class="btn btn-check-absent" [ngClass]="{'btn-request-absent': detail.isAbsent}" data-toggle="modal" 
                      (click)="openAbsentApprovalModal(detail.memberUserID)">Absent</button>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-2 leave-count no-padding text-center"
              routerLink="/teamMemberCalender/{{detail.memberUserID}}">
              <label class="count" id="leaveLeftCount">{{detail.leaveLeftCount}}</label>
              <label class="title">Leaves left</label>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
  <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker [latitude]="lat" [longitude]="lng">
    </agm-marker>
  </agm-map>
  <div class="modal fade" id="checkInModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <span *ngIf="error">{{ error }}</span>
            <span *ngIf="successMessageCheckOut">{{ successMessageCheckOut }}</span>
            <span *ngIf="successMessageCheckIn">{{ successMessageCheckIn }}</span>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
        </div>

      </div>
    </div>
  </div>
  
  <!-- Check In modal -->
  <div class="modal fade" id="supervisorCheckInModal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Check In Approve</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <span *ngIf="checkInfo" style="text-align: center; color: blue;">Click on selected status again to deselect it.</span>
        <div class="modal-body">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Day & Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let checkin of paginatedDataCheckIn; let i = index">
                <td>{{ (currentPage - 1) * recordsPerPage + i + 1 }}</td>
                <td>
                  {{ checkin.dateOfCheckIn | date: "EEE, d MMM yyyy" }}<br>
                  {{ checkin.dateOfCheckIn | date: "h:mm a" }}<br>
                  Distance: {{ checkin.range/1000 | number: '1.0-2' }} km
                </td>
                <td>
                  <div class="radio-group">
                    <div class="radio-line">
                      <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="OK" (click)="toggleStatus(checkin, 'OK')">
                      <label class="container-radio ml-2">OK
                        <!-- <span class="checkmark"></span> -->
                      </label>
                    </div>
                    <div class="radio-line">
                      <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Late" (click)="toggleStatus(checkin, 'Late')">
                      <label class="container-radio ml-2" style="margin-right: 68px;">Late
                        <!-- <span class="checkmark"></span> -->
                      </label>
                    </div>
                    <div class="radio-line">
                      <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="HalfDay" (click)="toggleStatus(checkin, 'HalfDay')">
                      <label class="container-radio ml-2">Half Day
                        <!-- <span class="checkmark"></span> -->
                      </label>
                    </div>
                    <div class="radio-line">
                      <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Unapproved" (click)="toggleStatus(checkin, 'Unapproved')">
                      <label class="container-radio ml-2">Unapproved
                        <!-- <span class="checkmark"></span> -->
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination">
            <button *ngFor="let page of totalPagesCheckIn" [class.active]="page === currentPage" (click)="setPage(page)">{{page }}</button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="submitCheckInApproval()">Submit</button>
        </div>
      </div>
    </div>
  </div> 


<!-- Check Out modal -->
<div class="modal fade" id="supervisorCheckOutModal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Check Out Approve</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <span *ngIf="checkInfo" style="text-align: center; color: blue;">Click on selected status again to deselect it.</span>
      <div class="modal-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Day & Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let checkin of paginatedDataCheckOut; let i = index">
              <td>{{ (currentPage - 1) * recordsPerPage + i + 1 }}</td>
              <td>
                {{ checkin.dateOfCheckIn | date: "EEE, d MMM yyyy" }}<br>
                <span *ngIf="checkin.checkOutStatus">
                  {{ checkin.dateOfCheckIn | date: "h:mm a" }}<br>
                  Distance: {{ checkin.range/1000 | number: '1.0-2' }} km
                  </span>
                  <span *ngIf="!checkin.checkOutStatus">Checkout Pending</span>
              </td>
              <td>
                <div class="radio-group">
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="OK" (click)="toggleStatus(checkin, 'OK')">
                    <label class="container-radio ml-2">OK
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Late" (click)="toggleStatus(checkin, 'Late')">
                    <label class="container-radio ml-2" style="margin-right: 68px;">Late
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="HalfDay" (click)="toggleStatus(checkin, 'HalfDay')">
                    <label class="container-radio ml-2">Half Day
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Unapproved" (click)="toggleStatus(checkin, 'Unapproved')">
                    <label class="container-radio ml-2">Unapproved
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination">
          <button *ngFor="let page of totalPagesCheckOut" [class.active]="page === currentPage" (click)="setPage(page)">{{
            page }}</button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitCheckOutApproval()">Submit</button>
      </div>
    </div>
  </div>
</div>

<!--Absent approval modal-->                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
<div class="modal fade" id="supervisorAbsentModal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Absent Days</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <span *ngIf="checkInfo" style="text-align: center; color: blue;">Click on selected status again to deselect it.</span>
      <div class="modal-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Day & Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let checkin of paginatedDataAbsent; let i = index">
              <td>{{ (currentPage - 1) * recordsPerPage + i + 1 }}</td>
              <td>
                {{ checkin.dateOfCheckIn | date: "EEE, d MMM yyyy" }}<br>
                <span *ngIf="checkin.checkInValue === 'Absent'">Check In: {{checkin.checkInValue}}<br></span>
                <span *ngIf="checkin.checkInValue !== 'Absent'">Check In: {{checkin.checkInValue | date: "h:mm a" }}<br></span>
                Check Out: {{checkin.checkOutValue}}
              </td>
              <td>
                <div class="radio-group">
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="OK" (click)="toggleStatus(checkin, 'OK')">
                    <label class="container-radio ml-2">OK
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Late" (click)="toggleStatus(checkin, 'Late')">
                    <label class="container-radio ml-2" style="margin-right: 68px;">Late
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="HalfDay" (click)="toggleStatus(checkin, 'HalfDay')">
                    <label class="container-radio ml-2">
                      <span *ngIf="checkin.checkInValue !== 'Absent'">Half Day</span>
                      <span *ngIf="checkin.checkInValue === 'Absent'">Leave</span>
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Unapproved" (click)="toggleStatus(checkin, 'Unapproved')">
                    <label class="container-radio ml-2">Unapproved
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination">
          <button *ngFor="let page of totalPagesAbsent" [class.active]="page === currentPage" (click)="setPage(page)">{{
            page }}</button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitAbsentApproval()">Submit</button>
      </div>
    </div>
  </div>
</div>     

<!--Leave Approval modal-->
<div class="modal fade" id="supervisorLeaveApproveModal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Leave Days</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <span *ngIf="checkInfo" style="text-align: center; color: blue;">Click on selected status again to deselect it.</span>
      <div class="modal-body">
        <table class="table table-bordered" style="border-collapse:collapse; table-layout:fixed;">
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Reason & Dates</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let checkin of paginateDataLeave; let i = index">
              <td>{{ (currentPage - 1) * recordsPerPage + i + 1 }}</td>
              <td style="word-wrap:break-word;">
                Reason : {{checkin.comment}}<br>
                Date:<span *ngFor="let leaveDate of checkin.dateOfLeave; let i = index">
                {{ leaveDate | date: "EEE, d MMM yyyy"}},</span>
              </td>
              <td>
                <div class="radio-group">
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Paid" (click)="toggleStatus(checkin, 'Paid')">
                    <label class="container-radio ml-2">Paid
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Unpaid" (click)="toggleStatus(checkin, 'Unpaid')">
                    <label class="container-radio ml-2">Unpaid
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                  <div class="radio-line">
                    <input type="radio" name="status-{{i}}" [(ngModel)]="checkin.status" value="Rejected" (click)="toggleStatus(checkin, 'Rejected')">
                    <label class="container-radio ml-2">Rejected
                      <!-- <span class="checkmark"></span> -->
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination">
          <button *ngFor="let page of totalPagesLeave" [class.active]="page === currentPage" (click)="setPage(page)">{{
            page }}</button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitLeaveApprove()">Submit</button>
      </div>
    </div>
  </div>
</div>

  <div class="modal fade" id="noDataFoundModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <label class="text-center">No Request Found</label>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer text-center">
            <div class="col">
              <button type="button" class="btn btn-secondary pull-left btn-check-in-modal"
                data-dismiss="modal">Ok</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>

   <!-- confirmation modal -->
   <div class="modal fade" id="confirmModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body text-center">
          <p>{{ confirmationMessage }}</p>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-primary" (click)="confirmCheckIn()">Yes</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
</section>